export const CREATE_WEDDING = 'zola/wedding/create';
export const UPDATE_WEDDING = 'zola/wedding/update';
export const REQUEST_WEDDING = 'zola/wedding/request';
export const RECEIVE_WEDDING = 'zola/wedding/receive';
export const RECEIVE_WEDDING_ACCOUNT = 'zola/wedding/receive_account';
export const THEME_REQUESTED = 'zola/wedding/THEME_REQUESTED';
export const THEME_RECEIVED = 'zola/wedding/THEME_RECEIVED';
export const THEMEGROUP_REQUESTED = 'zola/wedding/THEMEGROUP_REQUESTED';
export const THEMEGROUP_RECEIVED = 'zola/wedding/THEMEGROUP_RECEIVED';
export const TOGGLE_WEBSITE = 'zola/wedding/TOGGLE_WEBSITE';
export const ENABLE_GUEST_LIST_ONBOARDING = 'zola/wedding/ENABLE_GUEST_LIST_ONBOARDING';
export const DISABLE_WEBSITE_ONBOARDING = 'zola/wedding/DISABLE_WEBSITE_ONBOARDING';



/** WEBPACK FOOTER **
 ** ./src/actions/types/WeddingActionTypes.js
 **/